import { registerNodeType } from '../../registry'
import { ICONIFY } from '../../../../../Constants/iconify'
import TextFieldNode from './TextFieldNode'
import TextFieldConfig from './TextFieldConfig'

registerNodeType({
  type: 'TEXT_FIELD',
  label: 'Text Field',
  icon: ICONIFY.TEXT_FIELD,
  color: '#26A69A',
  hasOptions: false,
  excludeFields: [],
  defaults: {},
  nodeComponent: TextFieldNode,
  configComponent: TextFieldConfig,
})
